import React, { useState, useEffect } from 'react';
import { biography as defaultBio } from '../data/mock';
import { Award, Gem, Clock, Users } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const valueIcons = {
  "Savoir-faire": Award,
  "Qualité": Gem,
  "Expertise": Clock,
  "Partenariat": Users
};

const BiographySection = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch(`${API_URL}/api/content`);
        if (response.ok) {
          setContent(await response.json());
        }
      } catch (error) {
        console.error('Error fetching content:', error);
      }
    };
    fetchContent();
  }, []);

  const biography = content ? {
    title: "Notre Histoire",
    subtitle: content.biography_subtitle,
    paragraphs: [content.biography_paragraph1, content.biography_paragraph2, content.biography_paragraph3].filter(Boolean)
  } : defaultBio;

  return (
    <section id="histoire" className="py-24 md:py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-stone-500 text-sm tracking-[0.25em] uppercase mb-3">
            Notre parcours
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-stone-800 font-light">
            {biography.title}
          </h2>
          <div className="w-16 h-px bg-stone-300 mx-auto mt-6" />
          {biography.subtitle && (
            <p className="text-stone-600 text-lg mt-6 italic">
              "{biography.subtitle}"
            </p>
          )}
        </div>

        {/* Biography Content */}
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left: Text */}
          <div className="space-y-6">
            {biography.paragraphs.map((paragraph, index) => (
              <p
                key={index}
                className="text-stone-600 leading-relaxed text-base md:text-lg"
              >
                {paragraph}
              </p>
            ))}
          </div>

          {/* Right: Values */}
          <div className="bg-white p-8 md:p-10 rounded-lg shadow-sm border border-stone-100">
            <h3 className="font-serif text-2xl text-stone-800 mb-8">
              Nos Valeurs
            </h3>
            <div className="grid gap-6">
              {defaultBio.values.map((value, index) => {
                const IconComponent = valueIcons[value.title] || Award;
                return (
                  <div
                    key={index}
                    className="flex items-start gap-4 group"
                  >
                    <div className="flex-shrink-0 w-12 h-12 rounded-full bg-stone-100 flex items-center justify-center group-hover:bg-stone-200 transition-colors duration-300">
                      <IconComponent className="w-5 h-5 text-stone-600" />
                    </div>
                    <div>
                      <h4 className="font-medium text-stone-800 mb-1">
                        {value.title}
                      </h4>
                      <p className="text-stone-500 text-sm">
                        {value.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Timeline Accent */}
        <div className="mt-20 flex items-center justify-center gap-8">
          <div className="h-px flex-1 bg-gradient-to-r from-transparent to-stone-300" />
          <div className="text-center">
            <span className="font-serif text-5xl md:text-6xl text-stone-300 font-light">
              1965
            </span>
            <p className="text-stone-500 text-sm mt-2">Date de création</p>
          </div>
          <div className="h-px flex-1 bg-gradient-to-l from-transparent to-stone-300" />
        </div>
      </div>
    </section>
  );
};

export default BiographySection;
